<div>
    <div [formGroup]="form">
        <mat-form-field fxFlex="100%" class="p-16" appearance="outline" 
            style="max-height: 400px; overflow-y: auto;">
            <mat-label>{{data?.label}}</mat-label>
            <mat-chip-listbox #chipList multiple formControlName="myControl"
                style="max-height: 400px; overflow-y: auto;">
                <mat-chip
                    *ngFor="let keyword of form?.get('myControl')?.value"
                    [selected]="keyword"
                    [value]="keyword"
                    [removable]="removable"
                    [selectable]="selectable"
                    (removed)="removeKeyword(keyword)">
                    {{keyword}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input  class="p-16"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addKeywordFromInput($event)">
            </mat-chip-listbox>
        </mat-form-field>
    </div>
    <div align="end">
        <button mat-raised-button color="accent" class="mx-4" (click)="onClose()">{{"BUTTONS.CLOSE" | translate}}</button>
    </div>
</div>
